import { GsbTenant } from "./gsb-subscription.model";
import { GsbUser } from "./gsb-user.model";

export class GsbLoadLog {
    _entDefName?: string;
    createDate?: Date;
    requestSize?: number;
    createdBy?: GsbUser;
    lastUpdatedBy?: GsbUser;
    lastUpdatedBy_id?: string;
    responseSize?: number;
    tenant_id?: string;
    title?: string;
    responseTime?: number;
    serverAvarage?: number;
    clusterName?: string;
    loadScore?: number;
    serverName?: string;
    requestCount?: number;
    createdBy_id?: string;
    lastUpdateDate?: Date;
    id?: string;
    tenant?: GsbTenant;

    constructor(obj?: Partial<GsbLoadLog>) {
        Object.assign(this, obj);
        this._entDefName = "GsbLoadLog";
    }
}